import type React from 'react';

import { Alert, AlertTitle, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';

type Props = {
  onClose: () => void;
  onEditProfile: () => void;
  open: boolean;
};

export const LrmOperatingLocationsWarningDialog: React.FC<Props> = ({
  onClose,
  onEditProfile,
  open,
}) => {
  const { t } = useTranslationWithPrefix('components.lrmWarning');

  return (
    <Dialog disablePortal maxWidth="md" onClose={onClose} open={open}>
      <DialogContent>
        <Alert
          severity="warning"
          sx={{
            '& .MuiAlert-icon': {
              fontSize: '1.5rem',
            },
            '& .MuiAlertTitle-root': {
              fontSize: '1.1rem',
              fontWeight: 600,
            },
            mt: 2,
          }}
        >
          <AlertTitle>{t('title')}</AlertTitle>
          {t('message')}
        </Alert>
      </DialogContent>
      <DialogActions sx={{ mb: 1, mx: 2 }}>
        <Stack direction="row" spacing={2} sx={{ justifyContent: 'flex-end', width: '100%' }}>
          <Button onClick={onClose} size="large" sx={{ minWidth: 100 }} variant="outlined">
            {t('buttons.later')}
          </Button>
          <Button onClick={onEditProfile} size="large" sx={{ minWidth: 140 }} variant="contained">
            {t('buttons.editProfile')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
